import { avc1 } from './avc1.js';
/**
 * Parse a VisualSampleEntryBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed VisualSampleEntryBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function avc4(view) {
    return avc1(view);
}
//# sourceMappingURL=avc4.js.map